import axios from "axios";

const headers = {
  "Access-Control-Allow-Origin": process.env.REACT_APP_API_ORIGIN,
  "Access-Control-Allow-Methods": "GET",
  "Access-Control-Allow-Headers": "Origin",
  accept: "application/json",
};

export const FetchEventsData = async () => {
  const eventsUrl = process.env.REACT_APP_API_EVENTS;
  try {
    const response = await axios.get(eventsUrl, {
      headers: headers,
    });
    const { archive, upcoming, ongoing } = response.data.message;
    return {
      archive,
      upcoming,
      ongoing,
    };
  } catch (error) {
    // console.log("Something went wrong");
  }
};

export const fetchChallenges = async (id) => {
  const Challengesurl = process.env.REACT_APP_API_CHALLENGES;
  try {
    const response = await axios.get(Challengesurl, {
      headers: headers,
      params: {
        id: id,
      },
    });
    return response.data.message;
  } catch (error) {
    // console.log("Something went wrong");
  }
};

export const fetchEventDetails = async (id) => {
  const Eventdetailsurl = process.env.REACT_APP_API_EVENTSDETAILS;
  try {
    const response = await axios.get(Eventdetailsurl, {
      headers: headers,
      params: {
        id: id,
      },
    });
    return response.data.message;
  } catch (error) {
    // console.log("Something went wrong");
  }
};

export const fetchChallengeDetails = async (eventId, challengeId) => {
  const Challengdetailseurl = process.env.REACT_APP_API_CHALLENGESDETAILS;
  try {
    const response = await axios.get(Challengdetailseurl, {
      headers: headers,
      params: {
        eventId: eventId,
        challengeId: challengeId,
      },
    });
    return response.data.message;
  } catch (error) {
    // console.log("Something went wrong");
  }
};
